import getCurrentMainDomain from './getCurrentMainDomain'
import getSubdomain from './getSubdomain'

export default function isInSubdomain(...subdomains) {
  return !!getCurrentMainDomain() && subdomains.includes(getSubdomain())
}
